module.exports = __webpack_public_path__ + "static/main_text_ja-7f1333d2f97be3dfa2293b06566835c0.svg";